/*
 * Authors: mariushirjanu
 * Created: 15/02/2022
 */
import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../shared/http/http-data.service';

import { ICompany, IContact, IGenericUser } from '../../../../type_definitions/datatypes';

export interface IWebshopAccessSettingsRequest {
  emailSuffix:string;
  userApproval:boolean;
  approver:IContact;
  webshopId:number;
  genericUser:IGenericUser;
  defaultGenericUserName:string;
}

export interface IWebshopAccessSettings extends IWebshopAccessSettingsRequest {
  signupLink:string;
  company:ICompany;
  ticketLink?:string;
}

interface ITestEmailSuffixRequest {
  email:string;
  emailSuffix:string;
}

@Injectable()
export class WebshopAccessSettingsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public getAccessSettings(webshopId:number):Promise<IWebshopAccessSettings> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/access`,
      undefined,
      undefined,
      'Error loading access settings'
    );
  }

  public getExternalTicketLink(companyId:number):Promise<string> {
    return this.httpDataService.doGET(
      `rest/ticket/${companyId}/externallink`,
      undefined,
      undefined,
      'Error loading external ticket link'
    );
  }

  public saveAccessSettings(webshopId:number, data:IWebshopAccessSettingsRequest):Promise<IWebshopAccessSettings> {
    return this.httpDataService.doPUT(
      `rest/webshops/${webshopId}/access`,
      undefined,
      data,
      undefined,
      'Error saving access settings'
    );
  }

  public searchUserAdministrator(webshopId:number, filter:any):Promise<IContact[]> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/access/useradministrators`,
      { filter },
      undefined,
      'Error loading user administrators'
    );
  }

  public recreateGenericUsers(webshopId:number, defaultGenericUserName:string):Promise<void> {
    return this.httpDataService.doPOST(
      `rest/webshops/${webshopId}/access/genericusers?defaultGenericUserName=${defaultGenericUserName}`,
      undefined,
      undefined,
      undefined,
      'Error saving generic user'
    );
  }

  public testCompanyEmailSuffix(webshopId:number, data:ITestEmailSuffixRequest):Promise<any> {
    return this.httpDataService.doPOST(
      `rest/webshops/${webshopId}/access/emailsuffixes/test`,
      undefined,
      data,
      undefined,
      'Error testing email suffix'
    );
  }
}